import styled from "@emotion/styled";

const Td = styled.td`
  border: 0.0625rem solid var(--csa-border);
  padding: 0.25rem 0.5rem;
`;

export default Td;
